import { elegir } from '../ui/layout-variant.tsx';
import { HistorialMobile } from './Historial.mobile.tsx';
import { HistorialDesktop } from './Historial.desktop.tsx';

export default elegir(HistorialMobile, HistorialDesktop);
